import React from "react";
import OxxoPay from "./paymethods/oxxopay";
import CardPay from "./paymethods/cardpay";
import MercadoPago from "./paymethods/mercadopago";

function step4(props) {
  const loguedIn = function () {
    return !!localStorage.getItem("usr");
  };

  const getIdCuenta = function () {
    if (loguedIn() && props.account) {
      return props.account.Cuentas[props.step2.concepto].id_Cuenta;
    }
    return -1; // Cuando no está logueado
  };

  if (props.step3.paymethod === "tarjeta") {
    return (
      <CardPay
        step1={props.step1}
        step2={props.step2}
        step3={props.step3}
        account={props.account}
      />
    );
  }

  if (props.step3.paymethod === "mercadopago") {
    return (
      <MercadoPago
        step1={props.step1}
        step2={props.step2}
        step3={props.step3}
        account={props.account}
      />
    );
  }

  return (
    <OxxoPay
      idCuenta={getIdCuenta()}
      amount={props.step2.cantidad}
      concept={props.step2.concepto}
      name={props.step1.nombres + " " + props.step1.apellidos}
      email={props.step1.correo}
      phone={props.step1.telefono}
      level={props.step1.nivel}
      carrer={props.step1.carrera}
      campus={props.step1.campus}
    />
  );
}

export default step4;
